import { StudentSkillStates } from '../models/StudentSkillState';
import { sortedByLabel } from '../models/FilterOptions';
import { SkillSubStates } from '../models/SkillState';
import { Skill } from '../models/Skill';
import { ProgressBar } from '../models/ProgressBar';

export const sortStudentSkillStatesBySkillName = (a: StudentSkillStates, b: StudentSkillStates) => {
  const nameA = a.skill.name!.toLowerCase();
  const nameB = b.skill.name!.toLowerCase();
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

export const sortSkillsByDifficulty = (a: Skill, b: Skill) => {
  if (a.difficulty && b.difficulty) {
    if (a.difficulty < b.difficulty) return -1;
    if (a.difficulty > b.difficulty) return 1;
  }
  return 0;
};

export const sortStudentSkillStatesByLabel = (
  elements: StudentSkillStates[],
  orderBy: string,
): StudentSkillStates[] => {
  if (orderBy === sortedByLabel.READINESS_SCORE) {
    const passedInferredSkillsSet = new Set<SkillSubStates>([
      SkillSubStates.INFERRED_VIA_DIAGNOSTIC,
      SkillSubStates.INFERRED_VIA_ASSESSMENT,
      SkillSubStates.INFERRED_VIA_EXITSLIP,
      SkillSubStates.PASSED_VIA_ASSESSMENT,
      SkillSubStates.PASSED_VIA_TEACHER,
      SkillSubStates.PASSED_VIA_EXITSLIP,
    ]);
    const filteredSkills = elements
      .filter(element => !passedInferredSkillsSet.has(element.skillSubstate.id as SkillSubStates))
      .sort((a, b) => b.readinessScore! - a.readinessScore!);
    const passedInferredSkills = elements.filter(element =>
      passedInferredSkillsSet.has(element.skillSubstate.id as SkillSubStates),
    );
    return [...filteredSkills, ...passedInferredSkills];
  } else if (orderBy === sortedByLabel.NAME) {
    return [...elements].sort(sortStudentSkillStatesBySkillName);
  } else {
    return elements;
  }
};

export const sortProgressBarByOrder = (a: ProgressBar, b: ProgressBar) => {
  if (a.order && b.order) {
    if (a.order < b.order) return -1;
    if (a.order > b.order) return 1;
  }
  return 0;
};

export const sortByKey = <T>(key: keyof T) => {
  return (a: T, b: T): number => {
    const valueA = String(a[key]).toLowerCase();
    const valueB = String(b[key]).toLowerCase();
    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;
    return 0;
  };
};

export const sortStandardsByCustomCriteria = (a: { order: number }, b: { order: number }) => {
  if (a.order && b.order) {
    if (a.order < b.order) return -1;
    if (a.order > b.order) return 1;
  }
  return 0;
};

export const sortByFirstNameThenLastName = (
  a: { firstName: string; lastName: string },
  b: { firstName: string; lastName: string },
) => {
  if (a.firstName === b.firstName) {
    return a.lastName.localeCompare(b.lastName);
  }
  return a.firstName.localeCompare(b.firstName);
};

export const sortByLabelWithDot = (a: { label: string }, b: { label: string }) => {
  const parseLabel = (label: string) => {
    const [main, sub] = label.split(' - ')[0].split('.').map(Number);
    return { main, sub };
  };

  const { main: mainA, sub: subA } = parseLabel(a.label);
  const { main: mainB, sub: subB } = parseLabel(b.label);

  if (mainA !== mainB) return mainA - mainB;
  return subA - subB;
};
